// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Paragraph.less';

/**
 * `Paragraph` is a block containing a single paragraph of [Text](#!/Text) with a bottom margin.
 */
const Paragraph = ({ baseClassName, className, children, component: Tag, ...props }) => (
    <Tag className={classNames(baseClassName, className)} {...props}>
        {children}
    </Tag>
);

Paragraph.propTypes = {
    /**
     * Content of the `Paragraph`.
     */
    children: PropTypes.node,
    /**
     * Component to render as the root element.
     */
    component: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Paragraph.defaultProps = {
    children: null,
    component: 'p',
    className: null,
    baseClassName: `${CLS_PREFIX}paragraph`,
};

export default Paragraph;



// WEBPACK FOOTER //
// ./components/Paragraph/Paragraph.js